import api from '@shared/services/api';

export const locationService = {

    getCountries: async () => {
        try {
            const response = await api.get('/countries/list');
            return response.data;
        } catch (error) {
            console.error('Error getting countries:', error);
            throw error;
        }
    },

    getRegionsByCountry: async (countryCode) => {
        try {
            const response = await api.get(`/regions/${countryCode}`);
            return response.data;
        } catch (error) {
            console.error('Error getting regions:', error);
            throw error;
        }

    },
    getSubRegionsByRegion: async (id) => {
        try {
            const response = await api.get(`/subregions/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting subregions:', error);
            throw error;
        }
    },

    getCitiesBySubRegion: async (id) => {
        try {
            const response = await api.get(`/cities/subregion/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error getting cities:', error);
            throw error;
        }
    }
};